"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInputFormat = exports.validateDatapoolName = exports.validateAddDatapool = exports.isEmpty = void 0;
var lodash_1 = __importDefault(require("lodash"));
var validator_1 = __importDefault(require("validator"));
var module_list_1 = require("../constants/module_list");
var isEmpty = function (value) {
    return value === undefined || value === null || value === '' || value.trim() === '';
};
exports.isEmpty = isEmpty;
var validateAddDatapool = function (body) {
    var errors = {};
    if (!body.moduleType || !validator_1.default.isIn(body.moduleType, module_list_1.moduleTypeValues)) {
        errors.datapoolType = "Type should be in ".concat(module_list_1.moduleTypeValues);
    }
    if (!body.name) {
        errors.name = 'Name is required';
    }
    // TODO validate that the dataSourceCode is correct and only belongs to the allowed type
    return lodash_1.default.pickBy(errors, lodash_1.default.identity);
};
exports.validateAddDatapool = validateAddDatapool;
var datapoolNameRegExp = /^[a-zA-Z 0-9.,+\-äöüßÄÖÜ()]*$/;
function validateDatapoolName(datapoolName) {
    if ((0, exports.isEmpty)(datapoolName)) {
        return { id: 'newDatapool.stepOne.error.missing_datapool_name' };
    }
    else if (datapoolName.length < 3 || datapoolName.length > 65) {
        return { id: 'newDatapool.stepOne.error.datapool_name_length' };
    }
    else if (!datapoolNameRegExp.test(datapoolName)) {
        return {
            id: 'newDatapool.stepOne.error.it_can_contain_only_alphanumeric_symbols_and_spaces_and_brackets',
        };
    }
    else {
        return undefined;
    }
}
exports.validateDatapoolName = validateDatapoolName;
function validateInputFormat(values) {
    var errors = {};
    var inputFormat = values.inputFormat;
    if ((0, exports.isEmpty)(inputFormat)) {
        errors.inputFormat = {
            id: 'newDatapool.stepOne.error.missing_datapool_input_format',
        };
    }
    return errors;
}
exports.validateInputFormat = validateInputFormat;
//# sourceMappingURL=datapool.js.map